function openRolexHeader() {
    var menu = document.querySelector("#rolex-header-links");

    if (menu) {
        menu.classList.toggle("open");
    }
}

function backToTopRolex() {
    const headerRolex = document.querySelector(".rolex-header-container");
    var headerRolexTop = 0;

    // if (headerRolex) {
    //     headerRolexTop = headerRolex.getBoundingClientRect().top;
    // }
    document.body.scrollTo({
        top: headerRolexTop,
        behavior: "smooth"
    })// For Safari
        document.documentElement.scrollTo({
        top: headerRolexTop,
        behavior: "smooth"
    })// For Chrome, Firefox, IE and Opera
}